export default __webpack_public_path__ + "static/media/79.6e416af4.png";